<template>
  <div>
    <div
      class="ticketsItem"
      v-for="type in list"
      :key="type.id"
      :style="{
        filter:
          date === nowDate &&
          !isPurchase(type.type.split('-')[0], type.type.split('-')[1])
            ? 'opacity(0.5)'
            : '',
      }"
    >
      <template v-if="ticket == '团体（专场）预约'">
        <p style="text-align:center">{{ type.title }}</p>
      </template>

      <template v-else>
        <span>
          <p>{{ type.title }}</p>
          <p>{{ toDay(date) }}{{ type.type }}（{{ type.left }}张）</p>
        </span>
        <span class="price">￥{{ price || '0.00' }}</span>
        <template v-if="date === nowDate">
          <span class="btn">
            <van-button
              :disabled="
                !isPurchase(type.type.split('-')[0], type.type.split('-')[1]) ||
                  type.left <= 0
              "
              @click="buyTicket(type.id, type.type)"
            >
              <p style="color: #E5423D !important;">{{ type.left > 0 ? '购买' : '已售罄' }}</p>
            </van-button>
          </span>
        </template>
        <template v-else>
          <span class="btn">
            <button :disabled="type.left <= 0" @click="buyTicket(type.id, type.type)">
              <p>{{ type.left > 0 ? '购买' : '已售罄' }}</p>
            </button>
          </span>
        </template>
      </template>
    </div>
  </div>
</template>

<script>
import moment from 'moment';

moment.locale('zh-cn');

export default {
  props: {
    list: {
      type: Array,
    },
    price: {
      type: String,
      default: '0.00',
    },
    date: {
      type: String,
    },
    useStyle: {
      type: Number,
    },
    ticket: {
      type: String,
      default: '',
    },
  },
  methods: {
    buyTicket(type, scene) {
      this.$emit('buy', type);
      sessionStorage.setItem('scene', scene);
    },
    // 传入一个时刻，用于判断该门票是否还能购买
    isPurchase(time, timeEnd) {
      // 选座模式判断该时段开始时间
      if (this.useStyle === 3) {
        if (time.split(':')[0] > this.nowTime.split(':')[0]) {
          return true;
        }
        if (time.split(':')[0] < this.nowTime.split(':')[0]) {
          return false;
        }
        if (time.split(':')[1] >= this.nowTime.split(':')[1]) {
          return true;
        }
      } else {
        // 其他模式判断该时段的结束时间
        if (timeEnd.split(':')[0] > this.nowTime.split(':')[0]) {
          return true;
        }
        if (timeEnd.split(':')[0] < this.nowTime.split(':')[0]) {
          return false;
        }
        if (timeEnd.split(':')[1] >= this.nowTime.split(':')[1]) {
          return true;
        }
      }

      return false;
    },
    // 传入时间返回周几
    toDay(date) {
      return moment(date).format('dddd');
    },
  },
  computed: {
    nowDate() {
      return moment().format('l');
    },
    nowTime() {
      return moment().format('LT');
    },
  },
};
</script>

<style lang="less" scoped>
.ticketsItem {
  height: 7vh;
  width: 90%;
  padding: 15px 0 5px;
  margin: 0 auto;
  border-bottom: 1px solid #eee;
  display: flex;
  align-items: center;
  justify-content: space-between;
  span {
    display: block;
    height: 100%;
  }
  span:first-child {
    // float: left;
    // width: 18%;
    p {
      text-align: center;
    }
    p:first-child {
      font-size: 2.6vh;
      margin-bottom: 7px;
    }
    p:last-child {
      color: #999;
      font-size: 1.8vh;
      line-height: 2;
    }
  }

  .price {
    // float: right;
    width: 25%;
    text-align: right;
    line-height: 7vh;
    color: #e5423d;
  }
  .btn {
    // float: right;
    width: 20%;
    text-align: center;
    button {
      width: 90%;
      height: 60%;
      background-color: transparent;
      // margin-top: 50%;
      transform: translate(0, 30%);
      color: #e5423d;
      font-size: 1.8vh;
      line-height: 100%;
      border: 1px solid #e5423d;
      border-radius: 3px;
      padding: 0;
    }
  }
}
</style>
